import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ContactusComponent } from './contactus/contactus.component'
import { ContactusRoutingModule } from './contactus-routing.module'
import { CustomTranslateModule } from '@flowaccount/landing'
import { CoreModule } from '../../core.module';
import { RecaptchaModule } from 'ng-recaptcha'
@NgModule({
  declarations: [ContactusComponent],
  imports: [
    CoreModule.forRoot(),
    CommonModule,
    RecaptchaModule,
    ContactusRoutingModule,
    CustomTranslateModule.forChild({ path: 'contactus' }),
  ],
})
export class ContactusModule {}
